module.exports = __webpack_public_path__ + "img/opcion.32861ae8.svg";